import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import {
  DEFAULT_TIMEOUT,
  HttpRequestMethods,
  IDP_APPS
} from '../../constants/utils';
import { HEADER_FEATURES } from '../../constants/utils/app.constants';
import { HeaderFooterMachCore } from '../../models/header-footer-mach-core';
import { ApiBuilder, AppConfigService, handleError } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class HeaderFooterMachCoreContentService {
  http = inject(HttpClient);
  appConfigService = inject(AppConfigService);
  headerFooterMachCoreJson$!: Observable<HeaderFooterMachCore>;

  _errorHandler = handleError.bind(this);

  getHeaderFooterMachCoreContent$(): Observable<HeaderFooterMachCore> {
    if (this.headerFooterMachCoreJson$) {
      return this.headerFooterMachCoreJson$;
    } else {
      this.headerFooterMachCoreJson$ = this.init().pipe(shareReplay(1));
      return this.headerFooterMachCoreJson$;
    }
  }

  private init = (): Observable<HeaderFooterMachCore> =>
    new ApiBuilder<undefined, HeaderFooterMachCore>(
      this.http,
      this.appConfigService
    )
      .app(IDP_APPS.HEADER)
      .endpointKey('HEADER_FOOTER_MACH_CORE')
      .method(HttpRequestMethods.GET)
      .errorHandler(this._errorHandler)
      .timeOut(DEFAULT_TIMEOUT)
      .library(HEADER_FEATURES.HEADER_FOOTER_MACH_CORE)
      .create();
}
